(function () {
  function makeFacade(wrap, iframe) {
    var src = iframe.getAttribute("src") || "";
    var m = src.match(/(?:youtube(?:-nocookie)?\.com\/embed\/)([A-Za-z0-9_-]{6,})/);
    if (!m) return;
    var id = m[1];

    var btn = document.createElement("button");
    btn.type = "button";
    btn.className = "sg-yt-facade";
    btn.setAttribute("aria-label", "Play size guide video");
    btn.innerHTML = '<span class="sg-yt-play" aria-hidden="true"></span>';

    var posters = ["maxresdefault", "sddefault", "hqdefault"];
    (function setPoster(i) {
      if (i >= posters.length) return;
      var url = "https://i.ytimg.com/vi/" + id + "/" + posters[i] + ".jpg";
      var probe = new Image();
      probe.onload = function () {
        if (posters[i] === "maxresdefault" && probe.naturalWidth < 1000) { setPoster(i + 1); return; }
        btn.style.backgroundImage = "url('" + url + "')";
      };
      probe.onerror = function () { setPoster(i + 1); };
      probe.src = url;
    })(0);

    btn.addEventListener("click", function () {
      var f = document.createElement("iframe");
      f.setAttribute("src", src + (src.indexOf("?") > -1 ? "&" : "?") + "autoplay=1");
      f.setAttribute("title", iframe.getAttribute("title") || "YouTube video player");
      f.setAttribute("frameborder", "0");
      f.setAttribute("allow", "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share");
      f.setAttribute("allowfullscreen", "");
      if (btn.parentNode) btn.parentNode.replaceChild(f, btn);
    });

    iframe.parentNode.replaceChild(btn, iframe);
  }

  function init() {
    var wraps = document.querySelectorAll(".size-guide-video");
    for (var i = 0; i < wraps.length; i++) {
      var wrap = wraps[i];
      if (wrap.getAttribute("data-sg-facade")) continue;
      var iframe = wrap.querySelector('iframe[src*="youtube.com/embed/"], iframe[src*="youtube-nocookie.com/embed/"]');
      if (!iframe) continue;
      wrap.setAttribute("data-sg-facade", "1");
      makeFacade(wrap, iframe);
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
